import { useSessionStorage } from 'usehooks-ts';
import { StoreKeys } from '@/common/constants';
import { useLagoon } from '@/hooks/useLagoon';
import { getPortalProps } from '@/common/Theme/utils';
import {
  EmptySSOPortalEligibilityData,
  SSOPortalEligibilityData,
} from 'api/src/dataModels/SSOPortalEligibilityData';
import {
  LagoonContainerConfigItem,
  filterAndFormatLagoonThemeConfigs,
  formatLagoonContainerConfigList,
} from '../utils/formatLagoonData';
import { PortalThemeProps } from '@/common/DataModel/PortalThemeProps';
import { PortalName } from '@/common/DataModel/PortalData';

export type UseGetThemePortalPropsResult = PortalThemeProps & {
  themeConfig: Record<PortalName, LagoonContainerConfigItem> | undefined;
};

export const useGetThemePortalProps = (): UseGetThemePortalPropsResult => {
  const [ssoPortalEligibilityData] =
    useSessionStorage<SSOPortalEligibilityData>(
      StoreKeys.SSO_PORTAL_ELIGIBILITY_DATA,
      EmptySSOPortalEligibilityData
    );
  const { portalSource, portalIdentifier } = ssoPortalEligibilityData ?? {};

  // Return portalSource, portalIdentifier from source as well as themeConfig version based on data from lagoon
  const lagoonContainerConfigList: LagoonContainerConfigItem[] =
    useLagoon('container-config')();
  const lagoonContainerConfig = formatLagoonContainerConfigList(
    lagoonContainerConfigList
  );
  const themeConfig = filterAndFormatLagoonThemeConfigs(lagoonContainerConfig);

  return {
    ...getPortalProps(portalSource, portalIdentifier, themeConfig),
    themeConfig,
  };
};
